export enum Variants {
  TEXT = 'text',
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
}
